import AdblockFence from './adblock_fence'

export default ($context = document) => {
  const $elem = $('.js-adblock-fence', $context)
  if ($elem.length > 0) {
    new AdblockFence($elem, 'js-adblock-fence')
  }
}
